module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/left-bottom-ac54c87d33cbcbddb9074f6b3043ea32.webp";